import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/app-config';
import { Capacitor } from '@capacitor/core';

export interface PlaceViewDayDto {
  date: string;        // ISO date string e.g. "2025-07-10"
  views: number;
  uniqueViewers: number;
}

export interface PlaceViewStatsDto {
  placeId: number;
  placeName: string;
  days: PlaceViewDayDto[];
  totalViews: number;
  uniqueViewers: number;
}

@Injectable({ providedIn: 'root' })
export class ActivityApi {
  private readonly baseUrl = `${AppConfig.apiBaseUrl}/api/activity`;
  private readonly analyticsUrl = `${AppConfig.apiBaseUrl}/api/analytics`;

  constructor(private http: HttpClient) {}

  trackAppOpened() {
    const platform = Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
    return this.http.post<void>(`${this.baseUrl}/app-opened`, { platform });
  }

  getPlaceViewStats(placeId: number, days = 7) {
    return this.http.get<PlaceViewStatsDto>(
      `${this.analyticsUrl}/places/${placeId}/views`,
      { params: { days: days.toString() } }
    );
  }
}
